<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right" style="font-size: 16px; margin-bottom: 25px;">
      <el-breadcrumb-item>数据转换引擎</el-breadcrumb-item>
      <el-breadcrumb-item>推送目标管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form :inline="true" :model="destSearch">
      <el-form-item>
        <el-select v-model="destSearch.destId" filterable clearable placeholder="请选择推送目标" size="small">
          <el-option v-for="item in destOptions" :key="item.destId" :label="item.destName" :value="item.destId"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="small" @click="handleDestSearch">查 询</el-button>
        <el-button type="success" icon="el-icon-plus" size="small" @click="handleAddDest">新 增</el-button>
      </el-form-item>
    </el-form>
    <!--推送目标列表-->
    <el-table :data="destTableData" stripe v-loading="destLoading" style="width: 100%;">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" class="demo-table-expand">
            <el-form-item v-for="(domain, index) in props.row.projectList" :key="domain.projectId" :prop="'domains.' + index + '.value'">
              <el-button type="danger" icon="el-icon-delete" title="删除" size="mini" @click="handleDeleteProject(domain, props.row.destId, props.row.destName)" circle />
              <el-button type="primary" icon="el-icon-setting" title="参数" size="mini" @click="handleProjectMate(domain, props.row.destId, props.row.destName)" circle />
              <span class="span-label">项目编号: </span><span style="margin-right:100px">{{ domain.projectId }}</span>
              <span class="span-label">项目名称：</span><span>{{ domain.projectName }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column prop="destId" label="推送目标ID"/>
      <el-table-column prop="destName" label="推送目标名称"/>
      <el-table-column prop="originalKey" label="操作" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" icon="el-icon-edit" @click="handleUpdateDest(scope.row)" plain>编 辑</el-button>
          <el-button size="mini" type="success" icon="el-icon-plus" @click="handleAddProject(scope.row)" plain>新增项目</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加或修改推送目标信息 -->
    <el-dialog :title="destTitle" :visible.sync="destOpen" width="400px" @close="closeDestDialog" :close-on-click-modal="false">
      <el-form ref="destForm" :model="destForm" :rules="destRules" label-width="80px">
        <el-form-item label="公司名称" prop="companyName">
          <el-input v-model="destForm.destName" placeholder="请输入推送目标名称" size="small"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="handleDestSave">确 定</el-button>
        <el-button size="small" @click="handleDestCancel">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 新增推送项目 -->
    <el-dialog title="新增推送项目" :visible.sync="projectOpen" width="700px" @close="closeProjectDialog" :close-on-click-modal="false">
      <el-steps :active="active" finish-status="success" align-center>
        <el-step title="选择项目"></el-step>
        <el-step title="填写参数"></el-step>
      </el-steps>
      <el-card shadow="never" v-show="isShowProject">
        <el-table :data="projectTableData" stripe v-loading="projectLoading" style="width: 100%" height="400">
          <el-table-column prop="projectId" label="项目编号" align="center"/>
          <el-table-column prop="projectName" label="项目名称" align="left" width="200px"/>
          <el-table-column prop="originalKey" align="right" width="280px">
            <template slot="header" slot-scope="scope">
              <el-input v-model="projectSearch.projectName" size="small" style="width: 250px" placeholder="输入项目名称搜索">
                <el-button slot="append" icon="el-icon-search" @click="handleProjectSearch"></el-button>
              </el-input>
            </template>
            <template slot-scope="scope">
              <el-button size="mini" @click="handleSelectProject(scope.row)">选 择</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
      <el-card shadow="never" v-show="isShowParamForm">
        <el-form :model="metaForm" ref="addProjectForm" label-width="80px" class="param-form">
          <el-form-item v-for="(meta, index) in metaForm.metas" :key="index" :prop="'metas.' + index + '.metaValue'"
            :rules="{required: true, message: '参数不能为空', trigger: 'change'}">
            <el-input v-model="meta.metaKey" style="width: 100px" placeholder="参数名称" size="small"/>
            <el-input v-model="meta.metaValue" style="width: 250px; margin-right: 10px;" placeholder="参数值" size="small"/>
            <el-button @click.prevent="removeParam(meta)" icon="el-icon-delete" size="small" type="danger" plain>删  除</el-button>
          </el-form-item>
          <el-form-item style="float: right">
            <el-button icon="el-icon-plus" size="small" @click="addParam">新增参数</el-button>
            <el-button type="primary" icon="el-icon-check" size="small" @click="handleSaveProject('addProjectForm')">提 交</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-dialog>

    <!-- 项目Mate -->
    <el-dialog :title="mateTitle" :visible.sync="mateOpen" width="650px" @close="closeMateDialog" :close-on-click-modal="false">
      <el-card shadow="never">
        <el-form :model="metaForm" ref="editMetaForm" label-width="80px" class="param-form">
          <el-form-item v-for="(meta, index) in metaForm.metas" :key="index" :prop="'metas.' + index + '.metaValue'"
                        :rules="{required: true, message: '参数不能为空', trigger: 'change'}">
            <el-input v-model="meta.metaKey" style="width: 100px" placeholder="参数名称" size="small"/>
            <el-input v-model="meta.metaValue" style="width: 250px; margin-right: 10px;" placeholder="参数值" size="small"/>
            <el-button @click.prevent="removeMeta(meta, index)" icon="el-icon-delete" size="small" type="danger" plain>删  除</el-button>
          </el-form-item>
          <el-form-item style="float: right">
            <el-button icon="el-icon-plus" size="small" @click="addMetaParam">新增参数</el-button>
            <el-button type="primary" icon="el-icon-check" size="small" @click="saveEditMeta('editMetaForm')">保  存</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </el-dialog>
  </div>
</template>

<script>
import {isEmpty} from '../../utils/common'
export default {
  name: 'PushDest',
  data () {
    return {
      destLoading: false,
      destSearch: {
        destId: null
      },
      destOptions: [],
      destTableData: [],
      destOpen: false,
      destTitle: null,
      destForm: {
        destId: null,
        destName: null
      },
      destRules: {
        destName: [
          {required: true, message: '推送目标名称不能为空', trigger: 'blur'}
        ]
      },
      projectLoading: false,
      projectSearch: {
        projectName: null,
        projectIds: []
      },
      projectTableData: [],
      projectOpen: false,
      active: 0,
      isShowProject: true,
      isShowParamForm: false,
      metaForm: {
        destId: null,
        projectId: null,
        projectName: null,
        metas: []
      },
      mateOpen: false,
      mateTitle: null
    }
  },
  created () {
    this.getDestSelect()
    this.queryPushDest()
  },
  methods: {
    // 查询推送目标下拉选
    getDestSelect () {
      this.axios.post('/pushDest/queryAll').then(res => {
        if (res.data.code === 200) {
          this.destOptions = res.data.data
        } else {
          this.$message({type: 'error', message: res.data.msg})
        }
      })
    },
    // 根据条件查询推送目标
    queryPushDest () {
      this.destLoading = true
      this.axios.post('/pushDest/queryListById', this.destSearch).then(res => {
        if (res.data.code === 200) {
          this.destTableData = res.data.data
        } else {
          this.$message({type: 'warning', message: res.data.msg})
        }
        this.destLoading = false
      })
    },
    // 根据条件查询
    handleDestSearch () {
      this.queryPushDest()
    },
    handleAddDest () {
      this.destTitle = '新增推送目标'
      this.destOpen = true
    },
    handleUpdateDest (row) {
      this.destTitle = '修改推送目标'
      this.destOpen = true
      this.destForm = row
    },
    handleDestCancel () {
      this.destOpen = false
      this.resetDestForm()
    },
    closeDestDialog () {
      this.handleDestCancel()
    },
    // 保存新增
    handleDestSave () {
      this.$refs['destForm'].validate(valid => {
        if (valid) {
          if (this.destForm.destId != null) {
            this.axios.post('/pushDest/update', this.destForm).then(res => {
              if (res.data.code === 200) {
                this.$message({type: 'success', message: '修改成功'})
                this.queryPushDest()
                this.destOpen = false
              } else {
                this.$message({type: 'warning', message: res.data.msg})
              }
            })
          } else {
            this.axios.post('/pushDest/add', this.destForm).then(res => {
              if (res.data.code === 200) {
                this.$message({type: 'success', message: '新增成功'})
                this.queryPushDest()
                this.destOpen = false
              } else {
                this.$message({type: 'warning', message: res.data.msg})
              }
            })
          }
        }
      })
    },
    // 重置推送目标Form
    resetDestForm () {
      this.destForm = {
        destId: null,
        destName: null
      }
    },
    // 新增项目
    handleAddProject (row) {
      this.active = 0
      this.projectOpen = true
      if (row.projectList !== null) {
        row.projectList.forEach((project) => {
          this.projectSearch.projectIds.push(project.projectId)
        })
      }
      this.getProjectList()
      // 推送目标ID
      this.metaForm.destId = row.destId
    },
    // 查询项目列表
    getProjectList () {
      this.projectLoading = true
      this.axios.post('/pushDest/getProjectListByParams', this.projectSearch).then(res => {
        if (res.data.code === 200) {
          this.projectTableData = res.data.data
        } else {
          this.$message({type: 'warning', message: res.data.msg})
        }
        this.projectLoading = false
      })
    },
    // 根据项目名称查询
    handleProjectSearch () {
      this.getProjectList()
    },
    // 选择项目
    handleSelectProject (row) {
      this.active = 1
      this.isShowProject = false
      this.isShowParamForm = true
      // 需要添加的项目ID
      this.metaForm.projectId = row.projectId
      this.metaForm.projectName = row.projectName
    },
    // 删除参数Form
    removeParam (item) {
      var index = this.metaForm.metas.indexOf(item)
      if (index !== -1) {
        this.metaForm.metas.splice(index, 1)
      }
    },
    // 新增参数Form
    addParam () {
      this.metaForm.metas.push({
        metaKey: null,
        metaValue: null
      })
    },
    // 提交新增项目参数
    handleSaveProject (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axios.post('/destProjectMeta/addProjectAndMeta', this.metaForm).then(res => {
            if (res.data.code === 200) {
              this.$message({type: 'success', message: res.data.msg})
              this.queryPushDest()
              this.projectOpen = false
              this.closeProjectDialog()
            } else {
              this.$message({type: 'error', message: res.data.msg})
            }
          })
        } else {
          return false
        }
      })
    },
    // 关闭新增项目弹出框
    closeProjectDialog () {
      this.projectOpen = false
      this.active = 0
      this.isShowProject = true
      this.isShowParamForm = false
      this.metaForm = {
        destId: null,
        projectId: null,
        projectName: null,
        metas: []
      }
      this.projectSearch = {
        projectName: null,
        projectIds: []
      }
    },
    // 删除推送项目
    handleDeleteProject (project, destId, destName) {
      this.$confirm('是否确认删除【' + destName + '->' + project.projectName + '】项目推送?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.axios.get('/pushDest/deleteProject/' + destId + '/' + project.projectId).then(res => {
          if (res.data.code === 200) {
            this.$message({type: 'success', message: '删除成功!'})
          } else {
            this.$message({type: 'error', message: res.data.msg})
          }
          this.queryPushDest()
        })
      }).catch(() => {
        this.$message({type: 'info', message: '已取消删除'})
      })
    },
    // 参数Mate
    handleProjectMate (project, destId, destName) {
      this.mateTitle = destName + '—' + project.projectName
      this.metaForm.destId = destId
      this.metaForm.projectId = project.projectId
      this.mateOpen = true
      this.getMetaList(project.projectId, destId)
    },
    getMetaList (projectId, destId) {
      this.axios.get('/destProjectMeta/getMetaList/' + destId + '/' + projectId).then(res => {
        if (res.data.code === 200) {
          this.metaForm.metas = res.data.data
        } else {
          this.$message({type: 'error', message: res.data.msg})
        }
      })
    },
    // 删除meta
    removeMeta (meta, index) {
      this.$confirm('是否确认删除【' + meta.metaKey + '】项目参数配置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.metaForm.metas.splice(index, 1)
      }).catch(() => {
        this.$message({type: 'info', message: '已取消删除'})
      })
    },
    // 新增metaParam
    addMetaParam () {
      this.metaForm.metas.push({
        metaKey: null,
        metaValue: null
      })
    },
    // 编辑保存meta
    saveEditMeta (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axios.post('/destProjectMeta/saveMeta', this.metaForm).then(res => {
            if (res.data.code === 200) {
              this.$message({type: 'success', message: res.data.msg})
            } else {
              this.$message({type: 'error', message: res.data.msg})
            }
          })
          this.closeMateDialog()
        } else {
          return false
        }
      })
    },
    closeMateDialog () {
      this.mateTitle = null
      this.mateOpen = false
      this.metaForm = {
        destId: null,
        projectId: null,
        projectName: null,
        metas: []
      }
    }
  }
}
</script>

<style scoped>
 /deep/ .el-table thead {
  color: #1a1a1a !important;
  font-weight:400;
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand .span-label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.param-form .el-form-item{
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/pageview/PushDest.vue